import styled from "styled-components";
import hamburger from "../assets/images/hamburger-icon.png";
import turqRect from "../assets/images/turquioze-rectangle.png";

export const Hamburger = styled.button`
  display: none;

  @media (max-width: 48rem) {
    display: block;
    margin-top: 1rem;
    z-index: 10;

    width: 3rem;
    height: 3rem;

    background-image: url(${hamburger});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    border: none;
    background-color: transparent;
    cursor: pointer;
  }
`;

export const CloseButton = styled.button`
  color: black;
  font-size: 2rem;
  font-weight: 800;
  padding: 0.2rem;
  background: none;
  border: none;

  height: 0;
  overflow: visible;

  opacity: ${(props) => (props.$isOpen ? 1 : 0)};
  transition: opacity 0.8s ease;

  cursor: pointer;
`;

export const VisitUsBtn = styled.a`
  background-image: url(${turqRect});
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;

  width: 18.75rem;
  height: 5.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  align-self: flex-start;
  margin-left: -25vw;
  margin-top: 4vh;

  border: none;
  background-color: transparent;
  cursor: pointer;

  color: white;
  font-size: 2rem;
  font-family: inherit;
  text-decoration: none;
  padding-bottom: 0.5rem;

  filter: drop-shadow(0 0.25rem 0.4rem rgba(0, 0, 0, 0.5));

  &:hover {
    transform: scale(1.04);
    transition: transform 0.1s ease;
  }

  @media (max-width: 48rem) {
    transform: scale(1);
    width: 9.6rem;
    height: 4rem;
    font-size: 1.4rem;
    margin-left: 0;
    align-self: center;
  }
`;
